function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoAnolis(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "uc-social"
  }, props), React.createElement("path", {
    fill: "#0A1633",
    fillRule: "evenodd",
    d: "M6.941 22L2 21.93v-9.233l.027.001A10.072 10.072 0 012 11.965C2 6.46 6.477 2 12 2s10 4.461 10 9.965c0 5.132-3.893 9.357-8.896 9.905l-.233.02c-.278 0-.537-.023-.778-.07l-.335-.106a3.06 3.06 0 01.802-5.996l.18.002c.733-.01 1.357.166 1.871.529l.177.134v-.01c.259.156.562.246.886.246.943 0 1.707-.761 1.707-1.7 0-.94-.764-1.7-1.707-1.7-.667 0-1.244.381-1.528.938l-.036.067a.383.383 0 01-.323.17l-2.853.149c-.223 0-.343-.124-.417-.297l2.095-3.094a.428.428 0 01.354-.187c.942 0 1.706-.761 1.706-1.7 0-.94-.764-1.7-1.706-1.7-.943 0-1.706.76-1.706 1.7 0 .333.096.645.265.906a.405.405 0 01-.01.397l-1.921 2.838-.167.122c-.738.574-1.154.54-1.249-.1v-2.005c0-.216.098-.418.261-.552l.1-.074c.386-.312.633-.789.633-1.323 0-.939-.764-1.7-1.706-1.7s-1.706.761-1.706 1.7a1.7 1.7 0 00.974 1.537l.069.064a.57.57 0 01.138.372V22z"
  }));
}

SvgLogoAnolis.clsName = 'icon-uc-social__logo-anolis';
SvgLogoAnolis.remarkName = 'unknown';
export default SvgLogoAnolis;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoAnolis.js
// module id = 2230
// module chunks = 17 18